import instance from "@/services/api";

export const tierWorkGroupAPI = {
  async getWorkGroups() {
    return await instance().get('/tier/work_group_dict/read/').then(res => res?.data)
  },
  async getWorkGroup(work_group_dict_id) {
    return await instance().get(`/tier/work_group_dict/get/${work_group_dict_id}/`).then(res => res?.data)
  },
  async saveWorkGroup(data) {
    return await instance().post('/tier/work_group_dict/modify/', data).then(res => res?.data)
  },
  async deleteWorkGroup(work_group_dict_id) {
    return await instance().delete(`/tier/work_group_dict/delete/${work_group_dict_id}/`).then(res => res?.data)
  },
  async getTasks(work_group_dict_id) {
    return await instance().get(`/tier/task_dict/read/?work_group_dict_id=${work_group_dict_id}`).then(res => res?.data)
  },
  async getTask(task_dict_id) {
    return await instance().get(`/tier/task_dict/get/${task_dict_id}/`).then(res => res?.data)
  },
  async saveTask(data) {
    return await instance().post('/tier/task_dict/modify/', data).then(res => res?.data)
  },
  async deleteTask(task_dict_id) {
    return await instance().delete(`/tier/task_dict/delete/${task_dict_id}/`).then(res => res?.data)
  },
  async getUnits() {
    return await instance().get('/preset/preset_material/unit/read/').then(res => res?.data)
  },
  
  // API для работы с задачами конкретной group работ (work_group_task_tab)
  async getWorkGroupTasks(work_group_id) {
    return await instance().get(`/tier/work_group_task/read/?work_group_id=${work_group_id}`).then(res => res?.data)
  },
  async addWorkGroupTask(work_group_id, task_dict_id) {
    return await instance().post('/tier/work_group_task/add/', { work_group_id, task_dict_id }).then(res => res?.data)
  },
  async deleteWorkGroupTask(work_group_id, task_dict_id) {
    return await instance().post('/tier/work_group_task/delete/', { work_group_id, task_dict_id }).then(res => res?.data)
  },
  async addWorkGroupTasksBulk(work_group_id, task_dict_ids) {
    return await instance().post('/tier/work_group_task/add_bulk/', { work_group_id, task_dict_ids }).then(res => res?.data)
  }
}

